<div class="inner-card flow-root column">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100" class="s-dis-block">
    <form class="filter-form" [formGroup]="EmployeSelectionFilterForm">
     
      <app-employee-filter></app-employee-filter>

      <div class="widget mr-20" id="emp-selection-alarma" *ngIf="selectionService.selectionPermissions.HasAlarma">
        <mat-form-field>
          <mat-label>Alarmas</mat-label>
          <mat-select class="full-width-multi-select" formControlName="Alarmas" multiple
            (ngModelChange)="SetFilterValues('alarmas')">
            <mat-option *ngFor="let alarma of alarmasOptions" [value]="alarma.value">{{alarma.text}}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <app-consentimiento-filter></app-consentimiento-filter>
      <app-ordern-filter (OrdernChange)="SetFilterValues('Ordern',$event)" class="m-r-20"></app-ordern-filter>
      
      <div class="mr-20" fxFlex.gt-sm="50" fxFlexAlign="center" id="emp-selection-bajas-empresa">
        <mat-checkbox formControlName="BajasEmpresa" (ngModelChange)="SetFilterValues('bajasEmpresa')">Bajas de Empresa
        </mat-checkbox>
      </div>

      <div class="mr-20" fxFlex.gt-sm="50" fxFlexAlign="center" id="emp-selection-bajas-empresa">
        <mat-checkbox formControlName="EmpresaSelec" (ngModelChange)="SetFilterValues('empresaSelec')">Solo empresa seleccionada
        </mat-checkbox>
      </div>
    
    </form>
  </div>
</div>